import { z } from 'zod'
import { uuidSchema } from '../validators/uuid.validator.js'
import { oauthScopeSchema } from '../constants/oauth-scopes.js'

/**
 * What the connect screen needs in order to ask.
 *
 * `clientName` is whatever the app called itself, and it may be empty.
 * `redirectHost` is the website the approval returns to, which is the part
 * the person should actually read.
 */
export const oauthConsentRequestDtoSchema = z.object({
  clientName: z.string(),
  redirectHost: z.string(),
  /** Every registered return address is on this computer, not a public site. */
  loopbackOnly: z.boolean(),
  requestedScopes: z.array(oauthScopeSchema),
  expiresAt: z.string().datetime(),
})

export type OauthConsentRequestDto = z.infer<typeof oauthConsentRequestDtoSchema>

/** One connected app on the account page. */
export const oauthGrantDtoSchema = z.object({
  id: uuidSchema,
  clientName: z.string(),
  redirectHost: z.string(),
  scopes: z.array(oauthScopeSchema),
  createdAt: z.string().datetime(),
  expiresAt: z.string().datetime(),
})

export type OauthGrantDto = z.infer<typeof oauthGrantDtoSchema>

export const oauthGrantListDtoSchema = z.object({
  grants: z.array(oauthGrantDtoSchema),
})

export type OauthGrantListDto = z.infer<typeof oauthGrantListDtoSchema>

/** Where the browser goes after the person approves or refuses. */
export const oauthDecisionResultDtoSchema = z.object({
  redirectTo: z.string(),
})

export type OauthDecisionResultDto = z.infer<typeof oauthDecisionResultDtoSchema>
